import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { TypeRampV2 } from "../../../typography";
export const DatePickerMonthName = styled(TypeRampV2)`
    flex: 1 1 auto;
    margin-left: ${space.space20};
    color: ${color("color--text--neutral--strong")};
`;
//# sourceMappingURL=DatePickerMonthName.js.map